import React, { useContext } from 'react';
import styled from 'styled-components';
import { EditorContext } from '@/features/editor/context/editor-context';
import { DeviceType, WidgetType } from '@/utils/definitions';

interface ElementTrackingTipProps {
  device?: DeviceType;
}

export function ElementTrackingTip({ device }: ElementTrackingTipProps) {
  const { inspectorNav, showElementTrackingPinkTip } =
    useContext(EditorContext);
  if (inspectorNav?.currentWidget?.kind === WidgetType.TRACK_ELEMENT) {
    return (
      <Wrapper id="fooo" visible={showElementTrackingPinkTip} device={device}>
        ↓ Click the element you want to track ↓
      </Wrapper>
    );
  }
  return null;
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  padding: 1rem 2rem;
  border-radius: 1rem;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background-color: #ffd1f8;
  color: #d92784;
  opacity: ${(p) => (p.visible ? 1 : 0)};
  transition: opacity 1.5s ease;
  width: ${(props: { device: DeviceType }) =>
    props.device === DeviceType.Desktop ? `60%` : `40rem`};
  font-size: 1.4rem;

  @keyframes glow {
    0% {
      box-shadow: 0 0 0 rgba(217, 39, 132, 0);
    }
    50% {
      box-shadow: 0 0 20px rgba(217, 39, 132, 0.5);
    }
    100% {
      box-shadow: 0 0 0 rgba(217, 39, 132, 0);
    }
  }

  animation: ${(p) => (p.visible ? `glow 1.5s ease-in-out` : `none`)};
`;
